import React from 'react';

import UnityConfig from './types/UnityConfig';

/** UnityWarning component to display warnings */
interface UnityWarningLayerProps {
  config: UnityConfig;
}

const UnityWarningLayer: React.FC<UnityWarningLayerProps> = ({ config }) => {
  const [banners, setBanners] = React.useState<Array<{ id: number; msg: string; type: string }>>([]);
  const nextId = React.useRef(1);

  React.useEffect(() => {
    config.showBanner = (msg: string, type: string) => {
      const id = nextId.current++;
      setBanners((prev) => [...prev, { id, msg, type }]);
      if (type !== 'error') {
        setTimeout(() => {
          setBanners((prev) => prev.filter((b) => b.id !== id));
        }, 5000);
      }
    };
    return () => {
      config.showBanner = null;
    };
  }, [config]);

  return (
    <div id="unity-warning" style={{ display: banners.length ? 'block' : 'none', position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
      {banners.map((b) => (
        <div key={b.id} style={{
          backgroundColor: b.type === 'error' ? 'red' : b.type === 'warning' ? 'yellow' : undefined,
          color: b.type === 'error' ? 'white' : 'black',
          padding: '10px',
          marginBottom: '4px',
          border: b.type === 'error' ? '1px solid darkred' : b.type === 'warning' ? '1px solid orange' : undefined,
        }}>
          {b.msg}
        </div>
      ))}
    </div>
  );
}

export default UnityWarningLayer;
